module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    staticClass: "compact",
    attrs: {
      "outlined": "",
      "value": _vm.value[_vm.schema.name],
      "mandatory": false,
      "label": _vm.schema.label,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  }, _vm._l((_vm.schema.items), function(item, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": item.text || item.value,
        "value": item.value || item.text
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73e2ad5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/RadioControl.vue
// module id = 2603
// module chunks = 1